export default "__VITE_ASSET__310fad23__"